import { render, staticRenderFns } from "./DashboardV2.vue?vue&type=template&id=51959602&scoped=true"
import script from "./DashboardV2.vue?vue&type=script&lang=js"
export * from "./DashboardV2.vue?vue&type=script&lang=js"
import style0 from "./DashboardV2.vue?vue&type=style&index=0&id=51959602&prod&lang=css"
import style1 from "./DashboardV2.vue?vue&type=style&index=1&id=51959602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51959602",
  null
  
)

export default component.exports